<div class="bloco">
  <h5 class="titulo">E-mails</h5>
  <div *ngIf="naoEncontrouRegistros">
      <div class="row">
        <div class="col-auto item">Nenhum registro encontrado <i class="far fa-frown"></i></div>
      </div>
  </div>
  <div *ngIf="naoSolicitou">
      <div class="row">
          <div class="col-auto item">Você não solicitou essa consulta.</div>
        <!-- <div class="col-auto item"><button (click)="consultar()" [disabled]="consultando" class="btn btn-primary"><i class="fas fa-search"></i> Você não solicitou essa consulta. {{txtButtonConsultar}}</button></div> -->
      </div>
  </div>
  <div *ngIf="dados.email">
    <div class="row">
        <table class="table table-sm ">
            <thead>
              <tr>
                <th width="400">E-mail</th>
                <th width="200">Pontuação</th>
                <!-- <th>Atualizado há</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of dados.email">
                <td>{{row.email}}</td>
                <td>{{row.score}}</td>
                <!-- <td>{{row.recencia_meses}} mes(es)</td> -->
              </tr>
            </tbody>
          </table>
    </div>
  </div>
</div>
  
  